import { CustomizerFilter } from '../models';

export const isColorFilter = (filter: CustomizerFilter): boolean => {
  return filter.name.toLowerCase() === 'product_mobcolorhex';
};
